const projectAgent = {
  path: 'project-agent', // 项目代理
  component: () => import("@/views/home/project-agent/project-agent.vue"),
  children: [
    {
      path: 'apply', // 申请表单页
      component: () => import("@/views/home/project-agent/apply.vue"),
      meta: {
        tabBar: true,
        title: "上大夫慧活空间"
      },
    }, {
      path: 'success', // 申请成功页
      component: () => import("@/views/home/project-agent/success.vue"),
      meta: {
        tabBar: true,
        title: "上大夫慧活空间"
      },
    }, {
      path: 'info-lxz', // 粮芯藻
      component: () => import("@/views/home/project-agent/info-lxz.vue"),
      meta: {
        tabBar: false,
        title: "上大夫慧活空间"
      },
    },
  ]
};

export default projectAgent;
